module.exports = new __parcel__URL__("blueprint-darkmode.3429d36a.svg").toString();